const link = {
  inquiryEmail: "connect@60hz.io",
  connectURL: "https://connect.60hz.io",
  membersURL: "https://connect.60hz.io/members",
  sixtyURL: "https://60hz.io",
  mapURL: "https://map.60hz.io",
};
export default link;
